import React from "react";
import { Type } from "../PageDescription/_.styled";

const PageTitle = ({ children, ...props }) => {
  return (
    <Type
      className="heading"
      element="h1"
      color="gray800"
      fontFamily="secondary"
      {...props}
    >
      <span dangerouslySetInnerHTML={{ __html: children }} />
    </Type>
  );
};

export default PageTitle;
